import { render, staticRenderFns } from "./ProfileShow.vue?vue&type=template&id=82fbd968&"
import script from "./ProfileShow.vue?vue&type=script&lang=js&"
export * from "./ProfileShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports